jQuery(document).ready(function($) {
		
	/*
	########   ##     ##  ########   ##     ##  ########   ##         ########    ######    
	##          ##   ##   ##         ###   ###  ##     ##  ##         ##         ##    ##   
	##           ## ##    ##         #### ####  ##     ##  ##         ##         ##         
	######        ###     ######     ## ### ##  ########   ##         ######      ######    
	##           ## ##    ##         ##     ##  ##         ##         ##               ##   
	##          ##   ##   ##         ##     ##  ##         ##         ##         ##    ##   
	########   ##     ##  ########   ##     ##  ##         ########   ########    ######    
	*/
	// $('.outer-wrapper').imagesLoaded( function() {
	// 	var item = $('.reveal-anim');
	// 	var tweenCard = TweenMax.staggerFromTo(item, 0.5, { y: '50%', opacity: 0}, { y: '0%', opacity: 1}, 0.10 );
	// });
	
	// $('.menu-item--lev1').mouseenter(function(e) {
	// 	if (window.innerWidth >= 992) {
	// 		var item = $('.menu-item--lev2', this);
	// 		var tween = TweenMax.staggerFromTo(item, 0.5, {  y: '40', opacity: 0}, {  y: '0', opacity: 1}, 0.15 );
	// 	}
	// });
	// var sticky = new Waypoint.Sticky({
	// 	element: $('.nav-main')[0],
	// 	handler: function(dir) {
	//         $('.logo').toggleClass('is-fixed');
	//     },
	//     offset: -110
	// });

	// var stickyMain = new Waypoint.Sticky({
	// 	element: $('.header-main__container')[0],
	//     offset: -150
	// });

	// // Sous menu 
	// if ($('#nav-sub').length > 0 ) {
	// 	var stickySub = new Waypoint.Sticky({
	// 		element: $('#nav-sub'),
	// 		offset: 110,
	// 		stuckClass: 'stuck-sub'
	// 	});	
	// }

	// TIMELINE
	// var controller = new ScrollMagic.Controller();
	// $('.event').each(function() {
	// 	var tween =  TweenMax.to( this, 1, { rotationY: 0, opacity: 1 } );
	// 	var scene = new ScrollMagic.Scene({
	// 		triggerElement: this,
	// 		triggerHook: "onEnter",
	// 		duration: "20%"
	// 	})
	// 	.setTween( tween )
	// 	.addTo( controller );
	// });

	

	// // Banner home 
	// var bannerHome = new ScrollMagic.Controller();
	// 	var item   = $('.header-main--home');
	// 	//var tween  = TweenMax.to(item, 1, { backgroundPosition: '70% top', force3D: true, rotation: 0.01, z:0.01, ease: Linear.easeNone } );
	// 	var tween  = TweenMax.to(item, 1, { backgroundPosition: '70% top', ease: Linear.easeNone } );
	// 	var scene  = new ScrollMagic.Scene( { triggerHook: "onEnter", duration: "30%", offset: 1 } )
	// 		.setTween( tween )
	// 		// .addIndicators ( 'Banner' )
	// 		.addTo (bannerHome);

	

	// $('.key-figure').each(function() {
	// 	var tween =  TweenMax.fromTo( this, 1, { y: 100 }, { y: 20 } );
	// 	var scene = new ScrollMagic.Scene({
	// 		triggerElement: this,
	// 		triggerHook: "onEnter",
	// 		duration: "100%"
	// 	})
	// 	.setTween( tween )
	// 	.addTo( controller );
	// })


	/*
	 * Scroll control anim
	 */
	// var controller = new ScrollMagic.Controller();
	// 	var item  = $('.class');
	// 	var tween = TweenMax.fromTo(item, 1, { y: '100%'}, { y: '-30%'} );
	// 	var scene = new ScrollMagic.Scene( { triggerHook: "onEnter", duration: "100%" } )
	// 	.setTween( tween )
	// 	.addTo( controller );

});